import { Box, HStack, Image, useColorModeValue } from '@chakra-ui/react'
import { CheckIcon } from '@chakra-ui/icons'

interface FlagCheckboxProps {
  flagSrc: string
  flagAlt: string
  isChecked: boolean
  onChange: (checked: boolean) => void
  isDisabled?: boolean
}

export const FlagCheckbox = ({
  flagSrc,
  flagAlt,
  isChecked,
  onChange,
  isDisabled = false,
}: FlagCheckboxProps) => {
  const bgColor = useColorModeValue('white', 'gray.800')
  const borderColor = useColorModeValue('gray.200', 'gray.600')

  return (
    <Box
      position="relative"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      onClick={() => !isDisabled && onChange(!isChecked)}
    >
      <Box
        w="33px"
        h="26px"
        bg={bgColor}
        border="1px solid"
        borderColor={borderColor}
        borderRadius="4px"
        p={'3px'}
        position="relative"
        _hover={{
          borderColor: isDisabled ? borderColor : 'blue.300',
        }}
        transition="border-color 0.2s"
      >
        <Image
          src={flagSrc}
          alt={flagAlt}
          w="100%"
          h="100%"
          objectFit="cover"
          objectPosition={'center'}
          borderRadius="3px"
        />

        {isChecked && (
          <Box
            position="absolute"
            top="-6px"
            right="-7px"
            w="12px"
            h="12px"
            bg="blue.500"
            borderRadius="50%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxShadow="0 2px 4px rgba(0,0,0,0.1)"
          >
            <CheckIcon color="white" boxSize="2" />
          </Box>
        )}
        {!isChecked && (
          <Box
            position="absolute"
            top="-6px"
            right="-7px"
            w="12px"
            h="12px"
            bg={bgColor}
            borderRadius="50%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            border="2px solid"
            borderColor={borderColor}
            boxShadow="0 2px 4px rgba(0,0,0,0.1)"
          />
        )}
      </Box>
    </Box>
  )
}
